var _path, _path2, _path3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEngland = function SvgEngland(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 36 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0v24h36V0H0Z",
    fill: "#2E42A5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "England_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0v24h36V0H0Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#England_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "England_svg__b",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 24
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h36v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#England_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-4.009 22.285 7.922 2.978L36.18 3.238l4.178-4.426-8.471-.995-13.16 9.491-10.594 6.395-12.142 8.582Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.924 24.372 1.112 26.1 38.858-1.599H33.19l-36.115 25.97Z",
    fill: "#F50100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.008 22.285-7.921 2.978L-.18 3.238l-4.178-4.426 8.471-.995 13.16 9.491 10.594 6.395 12.141 8.582Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.738 23.782-4.036 1.729L19.63 13.65l-4.765-1.325L-4.76-1.173H.906L20.52 12.006l5.21 1.589 14.008 10.187Z",
    fill: "#F50100"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "England_svg__c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.25-2h-8.5V8H-2.219v8h15.97v10h8.5V16h16.03V8h-16.03V-2Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.25-2h-8.5V8H-2.219v8h15.97v10h8.5V16h16.03V8h-16.03V-2Z",
    fill: "#F50100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.75-2v-2h-2v2h2Zm8.5 0h2v-2h-2v2Zm-8.5 10v2h2V8h-2ZM-2.219 8V6h-2v2h2Zm0 8h-2v2h2v-2Zm15.97 0h2v-2h-2v2Zm0 10h-2v2h2v-2Zm8.5 0v2h2v-2h-2Zm0-10v-2h-2v2h2Zm16.03 0v2h2v-2h-2Zm0-8h2V6h-2v2Zm-16.03 0h-2v2h2V8Zm-8.5-8h8.5v-4h-8.5v4Zm2 8V-2h-4V8h4Zm-17.97 2h15.97V6H-2.22v4Zm2 6V8h-4v8h4Zm13.97-2H-2.22v4h15.97v-4Zm2 12V16h-4v10h4Zm6.5-2h-8.5v4h8.5v-4Zm-2-8v10h4V16h-4Zm18.03-2h-16.03v4h16.03v-4Zm-2-6v8h4V8h-4Zm-14.03 2h16.03V6h-16.03v4Zm-2-12V8h4V-2h-4Z",
    fill: "#fff",
    mask: "url(#England_svg__c)"
  })))));
};
export default SvgEngland;